/**
 * index.js
 *
 * This is the entry file for the application.
 */

import "react-hot-loader/patch";
import React from "react";
import ReactDOM from "react-dom";
import { ConfigProvider } from "antd";
import { ConnectedRouter } from "connected-react-router";

import { Provider, ReactReduxContext } from "react-redux";
import en_US from "antd/lib/locale-provider/en_US";

import { QueryClient, QueryClientProvider } from "react-query";

import Router from "./MainRouter";
import configureStore from "./store/configureStore";
import history from "./utils/history";

import "./styles/global.scss";
import { ThemeProvider } from "styled-components";
import styleVariables from "./styles/exports.module.scss";

import Auth from "aws-amplify";
Auth.configure({
  region: process.env.REACT_APP_COGNITO_REGION.replace(/['"]+/g, ""),
  userPoolId: process.env.REACT_APP_COGNITO_USERPOOL_ID.replace(/['"]+/g, ""),
  userPoolWebClientId: process.env.REACT_APP_COGNITO_WEBCLIENT_ID.replace(
    /['"]+/g,
    ""
  ),
  azureIdpName: process.env.REACT_APP_COGNITO_AZURE_IDP_NAME,
  oauth: {
    domain: `${process.env.REACT_APP_COGNITO_DOMAIN}`,
    scope: ["email", "profile", "openid"],
    // redirectSignIn: `http://localhost:3000`,                    // @TODO: UNCOMMENT to work locally
    redirectSignIn: `${process.env.REACT_APP_FRONTEND_BASE_URL}`,  // @TODO: COMMENT to work locally
    redirectSignOut: `${process.env.REACT_APP_FRONTEND_BASE_URL}`,
    responseType: "code",
  },
});

if (module.hot) {
  module.hot.accept("./MainRouter", () => {
    ReactDOM.render();
  });
}

// initialise redux store with empty initial state and history's browser history
const initialState = {};

const store = configureStore(initialState, history);
const ROOT_DOM_ELEMENT = document.getElementById("root");

// ENVIRONMENT VARIABLES TEST
// console.table(process.env);

// Create new react-query queryClient
// This unique queryClient instance will be passed to the QueryClientProvider component
// The queryClient instance will then be accessible in any components with the react-query useQueryClient hook
const queryClient = new QueryClient();

ReactDOM.render(
  <ConfigProvider locale={en_US}>
    <Provider store={store} context={ReactReduxContext}>
      <ThemeProvider theme={styleVariables}>
        <QueryClientProvider client={queryClient}>
          <ConnectedRouter history={history} context={ReactReduxContext}>
            <Router />
          </ConnectedRouter>
        </QueryClientProvider>
      </ThemeProvider>
    </Provider>
  </ConfigProvider>,
  ROOT_DOM_ELEMENT
);
